<template>
    <div>

        <v-card outlined class="card">
            <v-card-title>Paging Email Template<v-icon class="setting-scope-icon">mdi-account</v-icon></v-card-title>
            <v-divider />
            <v-card-text class="card-body">
                <div>
                    <v-select class="template-select" label="Selected Email Template" color="#c42111" :items="emailTemplates" v-model="$props.settings.pagingEmailTemplate" item-text="view_name" item-value="view_id" @change="selectedTemplateChange"></v-select>

                    <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                        <template v-slot:activator="{ on }">
                            <v-btn class="ml-3 view-button" min-width="30" width="30" dark small color="#c42111" @click="viewTemplatesClick" title="Save Alarm View" v-on="on">
                                <v-icon small>mdi-monitor-multiple</v-icon>
                            </v-btn>
                        </template>
                        <span>Template Library</span>
                    </v-tooltip>

                    <!-- <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                        <template v-slot:activator="{ on }">
                            <v-btn class="ml-3 view-button" min-width="30" width="30" dark small color="#c42111" @click="viewTemplatesClick" title="Save Alarm View" v-on="on">
                                <v-icon small>mdi-monitor-multiple</v-icon>
                            </v-btn>
                        </template>
                        <span>View available email templates</span>
                    </v-tooltip>

                    <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                        <template v-slot:activator="{ on }">
                            <v-btn class="ml-3 view-button" min-width="30" width="30" dark small color="#c42111" @click="addNewTemplateClick" title="Save Alarm View" v-on="on">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Create new email template</span>
                    </v-tooltip>

                    <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                        <template v-slot:activator="{ on }">
                            <v-btn class="ml-3 view-button" min-width="30" width="30" dark small color="#c42111" @click="editTemplateClick" title="Save Alarm View" v-on="on">
                                <v-icon>mdi-email-edit</v-icon>
                            </v-btn>
                        </template>
                        <span>Edit email template</span>
                    </v-tooltip>

                    <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                        <template v-slot:activator="{ on }">
                            <v-btn class="ml-3 view-button" min-width="30" width="30" dark small color="#c42111" @click="editTemplateClick" title="Save Alarm View" v-on="on">
                                <v-icon>mdi-file-eye</v-icon>
                            </v-btn>
                        </template>
                        <span>Preview email template</span>
                    </v-tooltip> -->

                </div>
            </v-card-text>
        </v-card>

        <v-dialog v-model="showEmailTemplates" max-width="80%" width="100%" persistent @keydown="(k) => {k.key == 'Escape' ? showEmailTemplates = false : null}">
            <email-templates :templateType="$props.templateType" :emailTemplates="emailTemplates" @get="getEmailTemplates" @close="showEmailTemplates = false" v-if="showEmailTemplates" />
        </v-dialog>
            
    </div>
                
</template>

<script>
import EmailTemplates from "@/components/Settings/EmailTemplates";
export default {
    name: 'Emails',
    props: ['settings', 'templateType'],
    components: {
        EmailTemplates
    },
    data: () => ({
        emailTemplates: [],
        showEmailTemplates: false 
    }),

    computed: {
    },

    methods: {
        viewTemplatesClick() {
            this.showEmailTemplates = true;
        },

        selectedTemplateChange() {
            console.log('select changed!');
        },

        addNewTemplateClick() {
            console.log('new template clicked!!');
            this.showEmailBuilder = true;
        },

        editTemplateClick() {
            console.log('EDIT template clicked!!');
        },

        getEmailTemplates() {
            let route = `${TELSA.apiHost}views/list/alarm_email`;
            return this.$http.get(route).then(response => {
                let results = response.body;
                this.emailTemplates = results;
            });
        },
    },

    mounted() {
        this.getEmailTemplates();
    }
};
</script>

<style scoped>

    .card {
        overflow-y: auto;
        max-height: calc(100vh - 200px);
        position: relative;
    }

    .card-body {
        overflow-y: auto;
        max-height: calc(100vh - 270px);
        position: relative;
    }

    .card-body .disabled {
        color: rgba(255, 255, 255, 0.5);
    }

    .template-select {
        width: calc(100% - 44px);
        display: inline-block;
    }

</style>
